import { useState, useEffect, useCallback } from 'react';
import { toast } from 'sonner';
import { api } from '@/lib/api';

export default function AdminBackupSuppliers() {
  const [farms, setFarms] = useState([]);
  const [categories, setCategories] = useState([]);
  const [designations, setDesignations] = useState({});

  const load = useCallback(async () => {
    const [f, cap, des] = await Promise.all([api.get('/admin/farms'), api.get('/admin/capacity'), api.get('/admin/supplier-designations')]);
    setFarms(f.data.filter((x) => x.status === 'Approved' || x.status === 'Approved With Conditions'));
    setCategories(cap.data.map((c) => c.category));
    const map = {}; des.data.forEach((d) => { map[d.category] = d; });
    setDesignations(map);
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async (category, key, value) => {
    const cur = designations[category] || { category, primary_farm_id: null, backup_farm_id: null };
    const next = { ...cur, [key]: value || null };
    setDesignations({ ...designations, [category]: next });
    await api.post('/admin/supplier-designations', { category, primary_farm_id: next.primary_farm_id, backup_farm_id: next.backup_farm_id });
    toast.success(`${category} suppliers saved`);
  };

  const Select = ({ category, field }) => (
    <select value={designations[category]?.[field] || ''} onChange={(e) => save(category, field, e.target.value)} className="bg-cream border border-forest/20 rounded-xl px-3 py-2 font-manrope text-sm w-full" data-testid={`${field}-${category.replace(/[^a-z]/gi, '-')}`}>
      <option value="">— None —</option>
      {farms.map((f) => <option key={f.farm_id} value={f.farm_id}>{f.name}</option>)}
    </select>
  );

  return (
    <div data-testid="admin-backup">
      <p className="font-manrope text-dark/60 mb-6">Designate a primary and backup supplier per category. When a primary reports a shortage, you'll know who to fall back on. Reassignment always requires your approval.</p>
      <div className="bg-white rounded-2xl border border-forest/10 overflow-hidden">
        {categories.length === 0 ? <p className="p-12 text-center font-manrope text-dark/50">No categories with active supply yet.</p> : (
          <table className="w-full">
            <thead className="bg-cream"><tr>{['Category', 'Primary supplier', 'Backup supplier'].map((h) => <th key={h} className="px-4 py-3 text-left font-manrope text-sm font-semibold text-dark/60">{h}</th>)}</tr></thead>
            <tbody className="divide-y divide-forest/10">
              {categories.map((c) => (
                <tr key={c} data-testid={`designation-${c.replace(/[^a-z]/gi, '-')}`}>
                  <td className="px-4 py-3 font-playfair font-bold text-dark">{c}</td>
                  <td className="px-4 py-3"><Select category={c} field="primary_farm_id" /></td>
                  <td className="px-4 py-3"><Select category={c} field="backup_farm_id" /></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
